export const ADDRESS_LOADING = "ADDRESS_LOADING";
export const ADDRESS_SUCCESS = "ADDRESS_SUCCESS";
export const ADDRESS_FAILED = "ADDRESS_FAILED";

export const ADDRESS_ADD_LOADING = "ADDRESS_ADD_LOADING";
export const ADDRESS_ADD_SUCCESS = "ADDRESS_ADD_SUCCESS";
export const ADDRESS_ADD_FAILED = "ADDRESS_ADD_FAILED";

export const ADDRESS_REMOVE_LOADING = "ADDRESS_REMOVE_LOADING";
export const ADDRESS_REMOVE_SUCCESS = "ADDRESS_REMOVE_SUCCESS";
export const ADDRESS_REMOVE_FAILED = "ADDRESS_REMOVE_FAILED";

export const ADDRESS_UPDATE_QUESTION_LOADING = "ADDRESS_UPDATE_QUESTION_LOADING";
export const ADDRESS_UPDATE_QUESTION_SUCCESS = "ADDRESS_UPDATE_QUESTION_SUCCESS";
export const ADDRESS_UPDATE_QUESTION_FAILED = "ADDRESS_UPDATE_QUESTION_FAILED";

export const ADDRESS_SAVE_LOADING = "ADDRESS_SAVE_LOADING";
export const ADDRESS_SAVE_SUCCESS = "ADDRESS_SAVE_SUCCESS";
export const ADDRESS_SAVE_FAILED = "ADDRESS_SAVE_FAILED";

export const ADDRESS_VALIDATION_LOADING = "ADDRESS_VALIDATION_LOADING";
export const ADDRESS_VALIDATION_SUCCESS = "ADDRESS_VALIDATION_SUCCESS";
export const ADDRESS_VALIDATION_FAILED = "ADDRESS_VALIDATION_FAILED";


export const ADDRESS_SAVE_NEW_LOADING = "ADDRESS_SAVE_NEW_LOADING";
export const ADDRESS_SAVE_NEW_SUCCESS = "ADDRESS_SAVE_NEW_SUCCESS";
export const ADDRESS_SAVE_NEW_FAILED = "ADDRESS_SAVE_NEW_FAILED";

export const ADDRESS_VALIDATION_NEW_LOADING = "ADDRESS_VALIDATION_NEW_LOADING";
export const ADDRESS_VALIDATION_NEW_SUCCESS = "ADDRESS_VALIDATION_NEW_SUCCESS";
export const ADDRESS_VALIDATION_NEW_FAILED = "ADDRESS_VALIDATION_NEW_FAILED";

export const ADDRESS_ADD_NEW_LOADING = "ADDRESS_ADD_NEW_LOADING";
export const ADDRESS_ADD_NEW_SUCCESS = "ADDRESS_ADD_NEW_SUCCESS";
export const ADDRESS_ADD_NEW_FAILED = "ADDRESS_ADD_NEW_FAILED";
